function AdminPanel() {
  return (
    <div>
      <p>Futures Pages</p>
    </div>
  );
}

export default AdminPanel;
